import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-enter-custom-amount-dialog',
  templateUrl: './enter-custom-amount-dialog.component.html',
  styleUrls: ['./enter-custom-amount-dialog.component.scss']
})
export class EnterCustomAmountDialogComponent {
   form!: FormGroup;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<EnterCustomAmountDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { street: string; button: string }
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      amount: ['', [Validators.required, Validators.min(10), Validators.max(90)]],
    });
  }

  cancel(): void {
    this.dialogRef.close(null);
  }

  save(): void {
    if (this.form.valid) {
      const value = this.form.value.amount + '%'; 
      this.dialogRef.close(value);
    } else {
      this.form.markAllAsTouched();
    }
  }
}